export default "__VITE_ASSET__CAm9WAku__"